import React from 'react';
import ListManager from '../../Components/ListManager/ListManager';
import styles from './PostSettings.module.css';
import { useAuth } from '../../firebase/AuthContext';
import { addStateToFirestore, getStatesFromFirestore, deleteStateFromFirestore } from '../../firebase/stateService';

const PostSettings = () => {
  const { user } = useAuth();
  const [states, setStates] = React.useState([]);
  const [stateLoading, setStateLoading] = React.useState(true);
  const [selectedIds, setSelectedIds] = React.useState([]);

  const fetchStates = async () => {
    if (!user) return;
    setStateLoading(true);
    const data = await getStatesFromFirestore(user.uid, 'post');
    setStates(data);
    setSelectedIds([]);
    setStateLoading(false);
  };

  React.useEffect(() => {
    fetchStates();
    // eslint-disable-next-line
  }, [user]);

  const handleAddState = async (name) => {
    if (!name.trim()) return;
    await addStateToFirestore(name.trim(), user.uid, 'post');
    fetchStates();
  };

  const handleDeleteState = async (id) => {
    if (!window.confirm('本当に削除しますか？')) return;
    await deleteStateFromFirestore(id);
    fetchStates();
  };

  // 一括削除
  const handleBulkDelete = async (ids) => {
    if (!ids || ids.length === 0) return;
    if (!window.confirm('選択した状態をすべて削除しますか？')) return;
    for (const id of ids) {
      await deleteStateFromFirestore(id);
    }
    fetchStates();
  };

  // ListManagerで選択管理するため不要

  return (
    <div className={styles.container}>
      <h2 style={{marginBottom:24}}>投稿に関する設定</h2>
      <div style={{marginBottom:32}}>
        <ListManager
          title="状態管理"
          label="投稿の状態"
          description="投稿で使う状態（例：完成、未完成、下書き等）を追加・削除できます。"
          items={states}
          onAdd={handleAddState}
          onRemove={handleDeleteState}
          onBulkRemove={handleBulkDelete}
          loading={stateLoading}
        />
      </div>
    </div>
  );
};

export default PostSettings;
